import { useRef, useState } from "react";
import logoplaceholder from "../../assets/images/uploadcover.svg";
import {
  ErrorMessage,
  renderImages,
  validateEmail,
  validatePhone,
  validateRequired,
  validateZipCode,
} from "../../utlis/function";
import toast from "react-hot-toast";
import { callApi } from "../../services/ApiServices";
import { useGlobalStates } from "../../utlis/ClubsContext";
import CommonLoader from "../common/CommonLoader";
import AddressFieldsSection from "./AddressFieldsSection";
import GoogleAddressAutocomplete from "./GoogleAddressAutocomplete";

const fetchAddressFromLatLng = async (lat, lng) => {
  try {
    const res = await fetch(
      `https://maps.googleapis.com/maps/api/geocode/json?latlng=${lat},${lng}&key=${process.env.REACT_APP_GOOGLE_MAPS_API_KEY}`,
    );
    const data = await res.json();

    if (!data.results?.length) return null;

    const result = {
      city: "",
      state: "",
      country: "",
      zipCode: "",
    };

    for (const res of data.results) {
      for (const component of res.address_components) {
        const types = component.types;

        if (types.includes("locality") && !result.city)
          result.city = component.long_name;

        if (types.includes("administrative_area_level_1") && !result.state)
          result.state = component.long_name;

        if (types.includes("country") && !result.country)
          result.country = component.long_name;

        if (types.includes("postal_code") && !result.zipCode)
          result.zipCode = component.long_name;
      }
    }
    return result;
  } catch (err) {
    console.error("Reverse geocoding failed", err);
    return null;
  }
};

const AddClubOverview = ({
  formData,
  updateFormData,
  errors,
  setErrors,
  handleInputChange,
  activeStep, 
  steps,
  handleNext,
  setCompletedStep,
  completedStep,
  setIsDirty,
  isDirty,
}) => {
  const [logoLoading, setLogoLoading] = useState(false);
  const [logoImgLoaded, setLogoImgLoaded] = useState(false);

  const [ciLoading, setCILoading] = useState(false);
  const [whyPartnerLoading, setWhyPartnerLoading] = useState(false);
  const { clubId, setClubId } = useGlobalStates();
  const [isLoading, setIsLoading] = useState(false);
  const fieldsRef = useRef({});

  const resolveSelectedAddress = async (data) => {
    const {
      address,
      city,
      state,
      country,
      zipCode,
      latitude,
      longitude,
    } = data;

    let finalCity = city;
    let finalState = state;
    let finalCountry = country;
    let finalZip = zipCode;

    if (
      (!finalCity || !finalState || !finalCountry || !finalZip) &&
      latitude &&
      longitude
    ) {
      const geoData = await fetchAddressFromLatLng(latitude, longitude);

      if (geoData) {
        finalCity = finalCity || geoData.city;
        finalState = finalState || geoData.state;
        finalCountry = finalCountry || geoData.country;
        finalZip = finalZip || geoData.zipCode;
      }
    }

    return {
      address,
      city: finalCity,
      state: finalState,
      country: finalCountry,
      zipCode: finalZip,
      latitude,
      longitude,
    };
  };

  const handleFieldValidation = (name, value) => {
    const error = validateField(name, value);
    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  // const handleExtraAddressFieldValidation = (index, field, value) => {
  //   const error = validateField(field, value);

  //   setErrors((prev) => {
  //     const updatedExtraErrors = [...(prev.extraAddresses || [])];
  //     updatedExtraErrors[index] = {
  //       ...(updatedExtraErrors[index] || {}),
  //       [field]: error,
  //     };

  //     return {
  //       ...prev,
  //       extraAddresses: updatedExtraErrors,
  //     };
  //   });
  // };


const handleAddExtraAddress = () => {
  if (formData.extraAddresses.length >= 4) return;

  updateFormData({
    extraAddresses: [
      ...(formData.extraAddresses || []),
      {
        address: "",
        city: "",
        state: "",
        zipCode: "",
        country: "",
        latitude: null,
        longitude: null,
      },
    ],
  });

  setIsDirty(true);
};


const handleRemoveExtraAddress = (index) => {
  const updated = formData.extraAddresses.filter((_, i) => i !== index);

  updateFormData({
    extraAddresses: updated,
  });

  setIsDirty(true);
};

  const validateWhyPartnerField = (index, field, value) => {
    if (!validateRequired(value)) {
      return field === "heading"
        ? "Heading is required"
        : "Description is required";
    }
    return "";
  };

  const handleWhyPartnerValidation = (index, field, value) => {
    const error = validateWhyPartnerField(index, field, value);
    setErrors((prev) => {
      const updatedErrors = [...(prev.whyPartnerSections?.items || [])];
      if (!updatedErrors[index]) {
        updatedErrors[index] = {};
      }
      updatedErrors[index][field] = error;
      return {
        ...prev,
        whyPartnerSections: {
          ...prev.whyPartnerSections,
          items: updatedErrors,
        },
      };
    });
  };

  const handleLogoChange = async (e) => {
    updateFormData((prev) => ({
      ...prev,
      logo: "",
    }));
    const file = e.target.files[0];
    if (!file) {
      return;
    }
    setErrors((prev) => ({
      ...prev,
      logo: "",
    }));

    setLogoLoading(true);
    setLogoImgLoaded(false);
    try {
      const payload = new FormData();
      payload.append("file", file);
      const response = await callApi({
        method: "post",
        url: "file/upload",
        data: payload,
      });

      updateFormData({
        logo: {
          ...response,
          fileUrl: `${response.fileUrl}?v=${Date.now()}`,
        },
      });
    } catch (error) {
      console.log("error while upload the logo image", error);
      setLogoLoading(false);
    }
  };

  const validateAllImagesOnUploading = (file) => {
    const validTypes = ["image/jpeg", "image/png", "image/jpg", "image/webp"];
    const maxSize = 1 * 1024 * 1024; // 1MB

    if (!file) return "Image is required";

    if (!validTypes.includes(file.type)) {
      return "Images must be JPG, PNG";
    }

    if (file.size > maxSize) {
      return "Image must be less than 1MB";
    }

    return ""; // ✅ valid
  };

  const handleClubImageChange = async (e, index) => {
    const file = e.target.files[0];
    if (!file) return;
    const error = validateAllImagesOnUploading(file);
    if (error) {
      setErrors((prevErrors) => ({
        ...prevErrors,
        images: error,
      }));
      return;
    }
    setErrors((prevErrors) => ({
      ...prevErrors,
      images: "",
    }));

    try {
      setCILoading((prev) => ({ ...prev, [index]: true }));
      const payload = new FormData();
      payload.append("file", file);
      const response = await callApi({
        method: "post",
        url: "file/upload",
        data: payload,
      });
      if (response.status === 201) {
        const newImages = [...(formData.clubImages || [])];
        newImages[index] = response;
        updateFormData({ clubImages: newImages });
      }
    } catch (error) {
      console.log("error while uploading club images", error);
    } finally {
      setCILoading((prev) => ({ ...prev, [index]: false }));
    }
  };


  const handleWhyPartnerImageChange = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    const error = validateAllImagesOnUploading(file);
    if (error) {
      setErrors((prev) => ({
        ...prev,
        whyPartnerSections: {
          ...prev.whyPartnerSections,
          image: error,
        },
      }));
      return;
    }
    setErrors((prev) => ({
      ...prev,
      whyPartnerSections: {
        ...prev.whyPartnerSections,
        image: "",
      },
    }));

    const payload = new FormData();
    payload.append("file", file);
    try {
      setWhyPartnerLoading(true);

      const response = await callApi({
        method: "post", // or DELETE
        url: "file/upload",
        data: payload,
      });
      updateFormData({
        whyPartnerSections: {
          ...formData.whyPartnerSections,
          image: response,
        },
      });
      setIsDirty(true);
    } catch (error) {
      console.error("Error removing Why Partner image", error);
    } finally {
      setWhyPartnerLoading(false);
    }
  };


  const handleWhyPartnerChange = (index, field, value) => {
    const updatedItems = [...formData.whyPartnerSections.items];
    setIsDirty(true);
    updatedItems[index] = {
      ...updatedItems[index],
      [field]: value,
    };

    updateFormData({
      whyPartnerSections: {
        ...formData.whyPartnerSections,
        items: updatedItems,
      },
    });
  };

  const validateField = (name, value) => {
    switch (name) {
      case "logo":
        return !formData.logo ? "Logo is required" : "";

      case "clubName":
        return !validateRequired(value) ? "Club name is required" : "";
      case "clubTagline":
        return !validateRequired(value) ? "Club tagline is required" : "";
      case "description":
        if( !validateRequired(value)) return "Description is required" ;
        else if(value.length > 500) return "Description must not exceed 500 characters.";
        return "";

      case "emailAddress":
        if (!validateRequired(value)) return "Email is required";
        return !validateEmail(value)
          ? "Please enter a valid email address"
          : "";
      case "phoneNumber":
        if (!validateRequired(value)) return "Phone number is required";
        return !validatePhone(value) ? "Please enter a valid phone number" : "";
      case "streetAddress":
        return !validateRequired(value) ? "Address is required" : "";
      case "country":
        return !validateRequired(value) ? "Country is required" : "";
      case "state":
        return !validateRequired(value) ? "State is required" : "";
      case "city":
        return !validateRequired(value) ? "City is required" : "";
      case "zipCode":
        const zip = value.trim();
        if (!validateRequired(zip)) return "Zip code is required";
        if (zip.length < 3) return "Zip code must be at least 3 digits";
      // case "advertiserBenefitsTitle":
      //   return !validateRequired(value)
      //     ? "Advertiser benefits title is required"
      //     : "";
      // case "advertiserBenefitsDescription":
      //   return !validateRequired(value)
      //     ? "Advertiser benefits description is required"
      //     : "";
      // return !validateZipCode(zip) ? "Please enter a valid zip code" : "";
      default:
        return "";
    }
  };

  const validateWhyPartnerItems = () => {
    return formData.whyPartnerSections.items.map((item, index) => {
      if (index === 0) {
        return {
          heading: !validateRequired(item.heading) ? "Heading is required" : "",
          description: !validateRequired(item.description)
            ? "Description is required"
            : "",
        };
      }

      // Validate ONLY if user has started typing
      if (item.heading || item.description) {
        return {
          heading: !validateRequired(item.heading) ? "Heading is required" : "",
          description: !validateRequired(item.description)
            ? "Description is required"
            : "",
        };
      }
      return {
        heading: "",
        description: "",
      };
    });
  };

  const validateWhyPartnerImage = (file) => {

    if (!file) return "Image is required";

    return ""; // valid
  };

  const validateImages = () => {
    const images = Array.isArray(formData.clubImages)
      ? formData.clubImages.filter(Boolean)
      : [];

    //  ONE global error only
    if (images.length === 0) {
      return "At least one club image is required";
    }

    return ""; // no error
  };

  const validateAllFields = () => {
    let isValid = true;
    const newErrors = {};

    // 1. Validate SIMPLE fields
    const simpleFields = [
      "logo",
      "clubName",
      "clubTagline",
      "description",
      "emailAddress",
      "phoneNumber",
      "streetAddress",
      "country",
      "state",
      "city",
      "zipCode",
      "advertiserBenefitsTitle",
      "advertiserBenefitsDescription",
    ];
    simpleFields.forEach((field) => {
      const error = validateField(field, formData[field]);
      if (error) {
        newErrors[field] = error;
        isValid = false;
      }
    });

    // const extraAddressErrors = (formData.extraAddresses || []).map((item) => {
    //   const itemErrors = {};
    //   const hasAnyValue = Object.values(item || {}).some((value) =>
    //     value !== null ? String(value).trim() !== "" : false,
    //   );

    //   if (!hasAnyValue) {
    //     return itemErrors;
    //   }

    //   const zipError = validateField("zipCode", item.zipCode || "");
    //   if (zipError) {
    //     itemErrors.zipCode = zipError;
    //     isValid = false;
    //   }

    //   return itemErrors;
    // });

    // if (extraAddressErrors.some((item) => Object.keys(item).length > 0)) {
    //   newErrors.extraAddresses = extraAddressErrors;
    // }

    // 2. Validate CLUB IMAGES (at least one required)
    const clubImageError = validateImages();
    if (clubImageError) {
      newErrors.images = clubImageError;
      isValid = false;
    }

    // 3. Validate WHY PARTNER IMAGE
    const whyPartnerImageError = validateWhyPartnerImage(
      formData.whyPartnerSections?.image,
    );
    if (whyPartnerImageError) {
      newErrors.whyPartnerSections = {
        ...(newErrors.whyPartnerSections || {}),
        image: whyPartnerImageError,
      };
      isValid = false;
    }

    // 4. Validate WHY PARTNER ITEMS (if they exist)
    if (formData.whyPartnerSections?.items?.length > 0) {
      const whyPartnerItemErrors = validateWhyPartnerItems();
      const hasWhyPartnerItemErrors = whyPartnerItemErrors.some(
        (err) => err.heading || err.description,
      );
      if (hasWhyPartnerItemErrors) {
        newErrors.whyPartnerSections = {
          ...(newErrors.whyPartnerSections || {}),
          items: whyPartnerItemErrors,
        };
        isValid = false;
      }
    }

    // 5. Validate LOGO
    // if (!formData.logo) {
    //   newErrors.logo = "Logo is required";
    //   isValid = false;
    // }

    // Set ALL errors once
    setErrors((prev) => ({ ...prev, ...newErrors }));
    return { isValid, newErrors };
  };

const saveFormData = async () => {
    // Build addresses array with primary, optional, and extra addresses
    const addresses = [
      {
        contactAddress: formData.streetAddress,
        latitude: formData.latitude,
        longitude: formData.longitude,
        contactCity: formData.city,
        contactCountry: formData.country,
        contactZip: formData.zipCode,
        contactState: formData.state,

      },

      ...(formData.extraAddresses || [])
        .filter((item) => item.address && item.latitude && item.longitude)
        .map((item) => ({
          contactAddress: item.address,
          latitude: item.latitude,
          longitude: item.longitude,
          contactCity: item.city,
          contactCountry: item.country,
          contactZip: item.zipCode,
          contactState: item.state,
        })),
    ];

    let data = {
      clubLogo: formData?.logo?.id,
      clubName: formData.clubName,
      clubTagline: formData.clubTagline,
      description: formData.description,
      contactEmail: formData.emailAddress,
      contactPhone: formData.phoneNumber,
      partnerImage: formData.whyPartnerSections?.image?.id,
      clubImages: formData.clubImages?.map((image) => image?.id),
      advertiserBenefitsTitle: formData?.advertiserBenefitsTitle,
      advertiserBenefitsDescription: formData?.advertiserBenefitsDescription,
      websiteImage: formData?.clubImages?.[0]?.id,
      addresses,
      partnerSolutions: [
        {
          heading: formData.whyPartnerSections.items[0].heading,
          description: formData.whyPartnerSections.items[0].description,
        },
        {
          heading: formData.whyPartnerSections.items[1].heading,
          description: formData.whyPartnerSections.items[1].description,
        },
        {
          heading: formData.whyPartnerSections.items[2].heading,
          description: formData.whyPartnerSections.items[2].description,
        },
      ],
    };
    let payload = {
      fields: {
        clubLogo: formData.logo?.id,
        clubName: formData.clubName,
        clubTagline: formData.clubTagline,
        description: formData.description,
        contactEmail: formData.emailAddress,
        contactPhone: formData.phoneNumber,
        partnerImage: formData.whyPartnerSections.image?.id,
        clubImages: formData.clubImages?.map((image) => image?.id),
        advertiserBenefitsTitle: formData?.advertiserBenefitsTitle,
        advertiserBenefitsDescription: formData?.advertiserBenefitsDescription,
        addresses,
        partnerSolutions: [
          {
            heading: formData.whyPartnerSections.items[0].heading,
            description: formData.whyPartnerSections.items[0].description,
          },
          {
            heading: formData.whyPartnerSections.items[1].heading,
            description: formData.whyPartnerSections.items[1].description,
          },
          {
            heading: formData.whyPartnerSections.items[2].heading,
            description: formData.whyPartnerSections.items[2].description,
          },
        ],
      },
    };
    console.log("payload when edit", payload);
    console.log("data when created", data);
    setIsLoading(true);
    try {
      const response = await callApi({
        method: clubId ? "put" : "post",
        url: clubId ? `club/update/${clubId}` : "club/create",
        data: clubId ? payload : data,
      });
      console.log("response api", response);
      if (!clubId && response.status === 201) {
        setClubId(response?.id);
        setCompletedStep(response?.stepUpdated || 1);
        toast.success("Club data saved successfully!", { id: "success" });
        setIsDirty(false);
      }
      if (clubId && response.status === 200) {
        setCompletedStep(response?.stepUpdated || 1);
        toast.success("Club data saved successfully!", {
          id: "clubDataSavedSuccessfully",
        });
        setIsDirty(false);
      }
      return response;
    } catch (error) {
      console.error("Error saving club data:", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };

  const scrollToFirstError = (errors) => {
    const findError = (obj) => {
      for (const key in obj) {
        if (typeof obj[key] === "string" && obj[key]) {
          return key;
        }
        if (typeof obj[key] === "object") {
          const nested = findError(obj[key]);
          if (nested) return key;
        }
      }
      return null;
    };

    const firstErrorField = findError(errors);

    if (firstErrorField && fieldsRef.current[firstErrorField]) {
      fieldsRef.current[firstErrorField].scrollIntoView({
        behavior: "smooth",
        block: "center",
      });
      fieldsRef.current[firstErrorField].focus?.();
    }
  };

  const handleSaveWithAPI = async () => {
    console.log("errors before save", errors)
    if (!isDirty && clubId) {
      toast("No changes to save");
      return;
    }
    const { isValid, newErrors } = validateAllFields();
    if (!isValid) {
      scrollToFirstError(newErrors);
      return;
    }
    try {
      const response = await saveFormData();
      if (response.status === 201) {
        //response.stepUpdated
        // toast.success('Club data saved successfully!');
      }
    } catch (error) {
      console.error("Error saving club:", error);
    }
  };

  const handleNextWithAPI = async () => {
    // If not saved yet OR data changed → save first
    if (!clubId || isDirty) {
      const { isValid, newErrors } = validateAllFields();
      if (!isValid) {
        scrollToFirstError(newErrors);
        return;
      }

      await saveFormData();
    }

    handleNext();
  };

  return (
    <>
      <div className="space-y-6">
        {isLoading && <CommonLoader />}
        {/* Basic Information */}
        <div className="bg-white rounded-xl p-6 main-shadow">
          <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal] mb-2">
            Basic Information
          </h2>
          <p className="text-lg font-normal text-textcolor tracking-[0] leading-[20px] mb-6">
            Add your club's essential identity details to appear across the
            platform.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div className="space-y-5">
              {/* Upload Logo */}
              <div className="flex flex-row gap-3">
                <div
                  className="flex-shrink-0 relative"
                  ref={(el) => (fieldsRef.current.logo = el)}
                >
                  <input
                    type="file"
                    id="logo-upload"
                    name="logo"
                    accept="image/png, image/jpeg, image/jpg"
                    onChange={handleLogoChange}
                    className="hidden"
                  />
                  <label
                    htmlFor="logo-upload"
                    className=" flex w-[60px] h-[60px] overflow-hidden  rounded-full cursor-pointer relative"
                  >
                    {formData.logo ? (
                      <img
                        src={formData.logo?.fileUrl}
                        // alt="Logo preview"
                        className="h-full w-full object-cover rounded-full"
                        onLoad={() => {
                          setLogoImgLoaded(true);
                          setLogoLoading(false);
                        }}
                      />
                    ) : (
                      <>
                        <img
                          src={logoplaceholder}
                          alt="Logo placeholder"
                          className=""
                        />
                      </>
                    )}
                    {logoLoading && (
                      <div className="absolute inset-0 flex items-center justify-center bg-black/40">
                        <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin" />
                      </div>
                    )}
                  </label>
                </div>
                <div className="">
                  <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
                    Upload logo
                  </label>
                  <p className="text-sm font-normal text-textcolor tracking-[0] leading-[normal] mb-3">
                    Format png, jpg
                  </p>
                </div>
              </div>
              <ErrorMessage message={errors.logo} />

              {/* Club Tagline */}
              <div>
                <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
                  Club Tagline
                </label>
                <input
                  ref={(el) => (fieldsRef.current.clubTagline = el)}
                  type="text"
                  placeholder="Enter club tagline"
                  name="clubTagline"
                  value={formData.clubTagline}
                  onChange={(e) => {
                    handleInputChange(e);
                    handleFieldValidation(e.target.name, e.target.value);
                  }}
                  className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border focus:outline-none focus:border-primary transition-colors ${
                    errors.clubTagline ? "border-red-500" : "border-gray-200"
                  }`}
                />
                <ErrorMessage message={errors.clubTagline} />
              </div>
            </div>

            {/* Club Name */}
            <div>
              <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
                Club Name
              </label>
              <input
                ref={(el) => (fieldsRef.current.clubName = el)}
                type="text"
                placeholder="Enter club name"
                name="clubName"
                value={formData.clubName}
                onChange={(e) => {
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border focus:outline-none focus:border-primary transition-colors ${
                  errors.clubName ? "border-red-500" : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors.clubName} />
            </div>
          </div>

          {/* Description */}
          <div className="mt-6">
            <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
              Description
            </label>
            <textarea
              ref={(el) => (fieldsRef.current.description = el)}
              rows="4"
              placeholder="Write here..."
              name="description"
              value={formData.description}
              onChange={(e) => {
                handleInputChange(e);
                handleFieldValidation(e.target.name, e.target.value);
              }}
              className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border focus:outline-none focus:border-primary transition-colors resize-none ${
                errors.description ? "border-red-500" : "border-gray-200"
              }`}
            />
            <ErrorMessage message={errors.description} />
          </div>
        </div>

        {/* Contact Information */}
        <div className="bg-white rounded-xl p-6 main-shadow">
          <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal] mb-2">
            Contact Information
          </h2>
          <p className="text-lg font-normal text-textcolor tracking-[0] leading-[20px] mb-6">
            Provide the official contact and location details for communication
            and verification.
          </p>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {/* Email Address */}
            <div>
              <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
                Email Address
              </label>
              <input
                ref={(el) => (fieldsRef.current.emailAddress = el)}
                type="email"
                name="emailAddress"
                placeholder="Enter email address"
                value={formData.emailAddress}
                onChange={(e) => {
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border focus:outline-none focus:border-primary transition-colors ${
                  errors.emailAddress ? "border-red-500" : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors.emailAddress} />
            </div>

            {/* Phone Number */}
            <div>
              <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
                Phone Number
              </label>
              <input
                ref={(el) => (fieldsRef.current.phoneNumber = el)}
                type="number"
                name="phoneNumber"
                placeholder="Enter phone number"
                value={formData.phoneNumber}
                onChange={(e) => {
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border focus:outline-none focus:border-primary transition-colors ${
                  errors.phoneNumber ? "border-red-500" : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors.phoneNumber} />
            </div>

            {/* Street/Suite Address */}
            <div ref={(el) => (fieldsRef.current.streetAddress = el)}>
              <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
                Address
              </label>
              <GoogleAddressAutocomplete
                type="added"
                value={formData.streetAddress}
                onChange={(val) => {
                  updateFormData({
                    streetAddress: val,
                    latitude: null,
                    longitude: null,
                    city: "",
                    country: "",
                    zipCode: "",
                    state: "",
                  });
                }}
                onSelect={async (data) => {
                  const resolvedAddress = await resolveSelectedAddress(data);

                  updateFormData({
                    streetAddress: resolvedAddress.address,
                    city: resolvedAddress.city,
                    state: resolvedAddress.state,
                    country: resolvedAddress.country,
                    zipCode: resolvedAddress.zipCode,
                    latitude: resolvedAddress.latitude,
                    longitude: resolvedAddress.longitude,
                  });

                  setErrors((prev) => ({
                    ...prev,
                    streetAddress: "",
                    city: "",
                    state: "",
                    country: "",
                    zipCode: "",
                  }));

                  setIsDirty(true);
                }}
              />

              <ErrorMessage message={errors.streetAddress} />
            </div>


            {/* City */}
            <div>
              <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
                City
              </label>
              <input
                ref={(el) => (fieldsRef.current.city = el)}
                value={formData.city}
                readOnly
                placeholder="Enter city"
                name="city"
                // disabled={!formData.country}
                onChange={(e) => {
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border focus:outline-none focus:border-primary transition-colors ${
                  errors.city ? "border-red-500" : "border-gray-200"
                }`}
              >
              </input>
              <ErrorMessage message={errors.city} />
            </div>

            {/* State */}
            <div>
              <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
                State
              </label>
              <input
                ref={(el) => (fieldsRef.current.state = el)}
                value={formData.state}
                readOnly
                placeholder="Enter state"
                name="state"
                onChange={(e) => {
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border focus:outline-none focus:border-primary transition-colors ${
                  errors.state ? "border-red-500" : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors.state} />
            </div>

            {/* Zip Code */}
            <div>
              <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
                Zip Code
              </label>
              <input
                ref={(el) => (fieldsRef.current.zipCode = el)}
                type="number"
                name="zipCode"
                placeholder="Enter zip code"
                value={formData.zipCode}
                onChange={(e) => {
                  const zip = e.target.value;
                  if (zip.length > 6) {
                    return;
                  }
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border focus:outline-none focus:border-primary transition-colors ${
                  errors.zipCode ? "border-red-500" : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors.zipCode} />
            </div>

            {/* Country */}
            <div className="">
              <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
                Country
              </label>
              <input
                ref={(el) => (fieldsRef.current.country = el)}
                name="country"
                readOnly
                placeholder="Enter country"
                value={formData.country}
                onChange={(e) => {
                  handleInputChange(e);
                  handleFieldValidation(e.target.name, e.target.value);
                }}
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border focus:outline-none focus:border-primary transition-colors ${
                  errors.country ? "border-red-500" : "border-gray-200"
                }`}
              />
            <ErrorMessage message={errors.country} />
            </div>
            
          </div>
            {/* EXTRA ADDRESS (3rd one) */}
          {formData.extraAddresses?.map((item, index) => (
            <AddressFieldsSection
              key={index}
              label={`Address ${index + 2}`}
              type="added"
              value={item}
              // errors={errors.extraAddresses?.[index] || {}}
              editableZip
              showRemove
              onRemove={() => handleRemoveExtraAddress(index)}
              onChange={(val) => {
                const updated = [...formData.extraAddresses];

                updated[index] = {
                  ...updated[index],
                  address: val,
                  city: "",
                  state: "",
                  zipCode: "",
                  country: "",
                  latitude: null,
                  longitude: null,
                };

                updateFormData({ extraAddresses: updated });
                setIsDirty(true);
              }}
              onZipChange={(val) => {
                const zip = val.replace(/\D/g, "").slice(0, 6); ;
                const updated = [...formData.extraAddresses];

                updated[index] = {
                  ...updated[index],
                  zipCode: zip,
                };

                updateFormData({ extraAddresses: updated });
                // handleExtraAddressFieldValidation(index, "zipCode", zip);
                setIsDirty(true);
              }}
              onSelect={async (data) => {
                const resolvedAddress = await resolveSelectedAddress(data);
                const updated = [...formData.extraAddresses];

                updated[index] = resolvedAddress;

                updateFormData({ extraAddresses: updated });
                // handleExtraAddressFieldValidation(
                //   index,
                //   "zipCode",
                //   resolvedAddress.zipCode || "",
                // );
                setIsDirty(true);
              }}
            />
          ))}

          

          {/* ADD BUTTON */}
          {(formData.extraAddresses?.length || 0) < 4 && (
            <div className="flex justify-end mt-2">
              <button
                type="button"
                onClick={handleAddExtraAddress}
                className="text-primary text-sm font-medium hover:underline"
              >
                + Add another location
              </button>
            </div>
          )}
        </div>

        {/* Club Images */}
        <div className="bg-white rounded-xl p-6 main-shadow relative">
          <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal] mb-2">
            Club Images
          </h2>
          <p className="text-lg font-normal text-textcolor tracking-[0] leading-[20px] mb-6">
            Upload high-quality images to showcase your venue and all spaces.
          </p>

          <div
            className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4"
            ref={(el) => (fieldsRef.current.images = el)}
          >
            {[0, 1, 2, 3, 4].map((index) => (
              <div key={index} className="relative">
                <input
                  type="file"
                  id={`club-image-${index}`}
                  accept="image/*"
                  onChange={(e) => handleClubImageChange(e, index)}
                  className="hidden"
                />
                <label
                  htmlFor={`club-image-${index}`}
                  className="flex flex-col items-center justify-center bg-[#F4F4F4] aspect-square rounded-lg cursor-pointer transition-colors relative"
                >
                  {formData.clubImages?.[index] ? (
                    <>
                      <img
                        src={formData.clubImages[index]?.fileUrl}
                        alt={`Club ${index + 1}`}
                        className="w-full h-full object-cover rounded-lg"
                      />
                      {/* <button
                        type="button"
                        onClick={(e) => handleClubImageRemove(e, index)}
                        className="absolute top-1 right-1 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs transition-colors"
                        title="Remove image"
                      >
                        <svg
                          width="12"
                          height="12"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M18 6L6 18M6 6L18 18"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button> */}
                    </>
                  ) : (
                    !ciLoading[index] && (
                      <>
                        <svg
                          width="32"
                          height="32"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          className="text-gray-400 mb-2"
                        >
                          <path
                            d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M17 8L12 3M12 3L7 8M12 3V15"
                            stroke="currentColor"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                        <p className="text-lg font-medium text-black text-center">
                          Upload club image
                        </p>
                        <p className="text-sm font-normal text-textcolor text-center">
                          Format: JPG or PNG
                        </p>
                      </>
                    )
                  )}
                  {/* Spinner */}
                  {ciLoading[index] && (
                    <div className="absolute inset-0 flex items-center justify-center bg-black/40">
                      <div className="w-6 h-6 border-2 border-white border-t-transparent rounded-full animate-spin" />
                    </div>
                  )}
                </label>
                {/* {formData.clubImages?.[index] && !ciLoading[index] && (
                  <button
                    type="button"
                    onClick={(e) => handleClubImageRemove(e, index)}
                    className="absolute top-1 right-1 z-20
                   bg-red-500 hover:bg-red-600
                   text-white rounded-full w-6 h-6
                   flex items-center justify-center"
                  >
                    ✕
                  </button>
                )} */}
              </div>
            ))}
            <ErrorMessage message={errors.images} />
          </div>
        </div>

        {/* Why Partner Section */}
        <div className=" bg-white rounded-xl p-6 main-shadow">
          <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal] mb-2">
            Why Partner Section
          </h2>
          <p className="text-lg font-normal text-textcolor tracking-[0] leading-[20px] mb-6">
            Upload high-quality images to showcase your venue and all spaces.
          </p>
          {/* Upload Image */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center">
            <div
              className="relative"
              ref={(el) => (fieldsRef.current.whyPartnerSections = el)}
            >
              <input
                type="file"
                id={`why-partner-image`}
                accept="image/*"
                onChange={(e) => handleWhyPartnerImageChange(e)}
                className="hidden"
              />
              <label
                htmlFor={`why-partner-image`}
                className="flex flex-col items-center justify-center h-[500px] rounded-[8px] bg-[#F4F4F4] shadow-[0_1px_17.9px_1px_#DBDBDB] cursor-pointer transition-colors relative"
              >
                {formData.whyPartnerSections?.image ? (
                  <>
                    <img
                      src={formData.whyPartnerSections?.image?.fileUrl}
                      alt={`Partner`}
                      className="w-full h-full object-contain rounded-lg"
                    />
                  </>
                ) : (
                  !whyPartnerLoading && (
                    <>
                      <svg
                        width="48"
                        height="48"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        className="text-gray-400 mb-2"
                      >
                        <path
                          d="M21 15V19C21 19.5304 20.7893 20.0391 20.4142 20.4142C20.0391 20.7893 19.5304 21 19 21H5C4.46957 21 3.96086 20.7893 3.58579 20.4142C3.21071 20.0391 3 19.5304 3 19V15M17 8L12 3M12 3L7 8M12 3V15"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                      <p className="text-[30px] font-semibold text-black">
                        Upload club image
                      </p>
                      <p className="text-lg font-normal text-textcolor">
                        Format: JPG or PNG
                      </p>
                    </>
                  )
                )}
                {whyPartnerLoading && (
                  <div className="absolute inset-0 flex items-center justify-center bg-black/40">
                    <div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin" />
                  </div>
                )}
              </label>
              {/* {formData.whyPartnerSections?.image && !whyPartnerLoading && (
                <button
                  type="button"
                  onClick={handleLogoRemove}
                  className="absolute -top-1 -right-1 bg-red-500 hover:bg-red-600 text-white rounded-full w-6 h-6 flex items-center justify-center text-xs transition-colors"
                  title="Remove logo"
                >
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 24 24"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <path
                      d="M18 6L6 18M6 6L18 18"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>
                </button>
              )} */}

              <ErrorMessage message={errors.whyPartnerSections?.image} />
            </div>
            <div className="">
              {formData?.whyPartnerSections?.items?.map((section, index) => (
                <>
                  {/* Heading and Description */}
                  <div className="space-y-4">
                    <div
                      ref={(el) =>
                        (fieldsRef.current[`whyPartner-heading-${index}`] = el)
                      }
                    >
                      <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
                        Heading {index + 1}
                      </label>
                      <input
                        type="text"
                        placeholder="Write heading..."
                        value={section.heading}
                        onChange={(e) => {
                          handleWhyPartnerChange(
                            index,
                            "heading",
                            e.target.value,
                          );
                          handleWhyPartnerValidation(
                            index,
                            "heading",
                            e.target.value,
                          );
                        }}
                        className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border focus:outline-none focus:border-primary transition-colors ${
                          errors?.whyPartnerSections?.items?.[index]?.heading
                            ? "border-red-500"
                            : "border-gray-200"
                        }`}
                      />
                    </div>
                    {errors?.whyPartnerSections?.items?.[index]?.heading && (
                      <ErrorMessage
                        message={errors.whyPartnerSections.items[index].heading}
                      />
                    )}

                    <div>
                      <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
                        Description
                      </label>
                      <textarea
                        ref={(el) =>
                          (fieldsRef.current[
                            `whyPartner-description-${index}`
                          ] = el)
                        }
                        rows="4"
                        placeholder="Write description..."
                        value={section.description}
                        onChange={(e) => {
                          handleWhyPartnerChange(
                            index,
                            "description",
                            e.target.value,
                          );
                          handleWhyPartnerValidation(
                            index,
                            "description",
                            e.target.value,
                          );
                        }}
                        className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border focus:outline-none focus:border-primary transition-colors resize-none ${
                          errors?.whyPartnerSections?.items?.[index]
                            ?.description
                            ? "border-red-500"
                            : "border-gray-200"
                        }`}
                      />
                    </div>
                    {errors?.whyPartnerSections?.items?.[index]
                      ?.description && (
                      <ErrorMessage
                        message={
                          errors.whyPartnerSections?.items[index].description
                        }
                      />
                    )}
                  </div>
                </>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-white rounded-xl p-6 main-shadow">
          <h2 className="text-xl font-semibold text-black tracking-[0] leading-[normal] mb-2">
            Advertiser Benefits Section
          </h2>
          <p className="text-lg font-normal text-textcolor tracking-[0] leading-[20px] mb-6">
            Highlight the value advertisers will get by running campaigns with
            this club.
          </p>

          <div className="space-y-6">
            <div ref={(el) => (fieldsRef.current.advertiserBenefitsTitle = el)}>
              <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
                Title
              </label>
              <input
                type="text"
                name="advertiserBenefitsTitle"
                placeholder="Write title..."
                value={formData.advertiserBenefitsTitle}
                onChange={handleInputChange}
                onBlur={(e) =>
                  handleFieldValidation(e.target.name, e.target.value)
                }
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border focus:outline-none focus:border-primary transition-colors ${
                  errors?.advertiserBenefitsTitle
                    ? "border-red-500"
                    : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors?.advertiserBenefitsTitle} />
            </div>

            <div
              ref={(el) =>
                (fieldsRef.current.advertiserBenefitsDescription = el)
              }
            >
              <label className="block text-base font-medium text-black tracking-[0] leading-[normal] mb-2">
                Description
              </label>
              <textarea
                name="advertiserBenefitsDescription"
                rows="4"
                placeholder="Write description..."
                value={formData.advertiserBenefitsDescription}
                onChange={handleInputChange}
                onBlur={(e) =>
                  handleFieldValidation(e.target.name, e.target.value)
                }
                className={`w-full px-4 py-3 bg-white rounded-lg text-base font-normal text-black border focus:outline-none focus:border-primary transition-colors resize-none ${
                  errors?.advertiserBenefitsDescription
                    ? "border-red-500"
                    : "border-gray-200"
                }`}
              />
              <ErrorMessage message={errors?.advertiserBenefitsDescription} />
            </div>
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between mt-6">
        <button
          onClick={handleSaveWithAPI}
          disabled={isLoading}
          className="cursor-pointer px-2 h-[60px] w-[200px] border border-primary text-primary font-medium text-lg rounded-full transition-colors hover:bg-primary hover:text-white"
        >
          Save
        </button>
        <button
          onClick={handleNextWithAPI}
          disabled={isLoading}
          className="cursor-pointer px-2 h-[60px] w-[200px] border bg-primary hover:bg-hover text-white rounded-full text-primary font-medium text-lg transition-colors"
        >
          {activeStep === steps.length - 1 ? "Save" : "Next"}
        </button>
      </div>
    </>
  );
};

export default AddClubOverview;
